<div class="history-content">
  <h1 class="header-title">
    <span class="back" (click)="onBack()">
      <flame-icon svgIcon="chevron-left" />
    </span>
    {{ textTokens?.CAPTURA_TOP_BAR_TITLE}}
  </h1>
  <section class="card">
    <app-basic-card 
      type="navigation" 
      [picture]="{ value: 'mobile', type: 1 }"
      (click)="onNext()"
      class="item"
    ><p class="text-bold">Nueva recarga</p></app-basic-card>
  </section>
  <h2 class="title text-bold">Tus últimas recargas</h2>
  <div class="card">
    <app-basic-card 
      class="item" 
      type="navigation" 
      [picture]="getPicture(item)"
      *ngFor="let item of rechargeHistory"
      (click)="onNext(item)"
    >
        <p class="text-bold">{{item.name}}</p>
        <p>{{item.phoneNumber | phone}}</p>
        <p class="text-bold amount">{{item.amount | currency: 'MXN' : 'symbol' : '1.0-0'}}</p>
    </app-basic-card>
  </div>
</div>

